import { EXAM_NAME } from '../../constants/ShipmentConstants'
import NonstockExamTable from './NonstockExamTable'

const OffcycleExamTable = ({ suborder }) => (
  <div className="cb-scrollbar-container" style={{ margin: '0 7px' }}>
    <div className="cb-scrollbar top">
      <div className="cb-scrollbar-thumb" />
    </div>

    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th scope="col">{EXAM_NAME}</th>
            <th scope="col">Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">
              <p>{suborder.courseName}</p>
            </th>
            <td>1</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
)

export default ({ suborder }) => {
  // Offcycle Exams(no exam materials), or...
  // Offcycle Exams (with special materials)
  if (suborder.suborderHasNoExamMaterials || suborder.isSpecialMaterials) {
    return <OffcycleExamTable suborder={suborder} />
  }

  // Offcycle Exams (with nonstocked SSD)
  if (suborder.isNonstockedSsd) {
    // non stock
    return <NonstockExamTable suborder={suborder} />
  }

  // default
  return (
    <div className="cb-small-font-size" style={{ padding: '0 10px' }}>
      No data Available
    </div>
  )
}
